export enum PaymentDetailsDataHooks {
  PAYMENT_DETAILS = 'payment-details',
  PLAN_DETAILS = 'payment-plan-details',
  MEMBERSHIP = 'payment-membership',
  MEMBERSHIP_VALIDATION = 'payment-membership-validation',
  MEMBERSHIP_CREDIT = 'payment-membership-credit',
  CUSTOM_PRICE = 'payment-custom-price',
  PAY_NOW_SECTION = 'payment-pay-now-section',
  PAY_NOW_AMOUNT = 'payment-pay-now-amount',
  PAY_LATER_SECTION = 'payment-pay-later-section',
  PAY_LATER_AMOUNT = 'payment-pay-later-amount',
}
